const {toDateValue} = require('../memberStatus');

// Explicit half-open intervals, unlike deployments' inclusive calendar days.
const timeOffIntervalsByMember = (records = []) => {
    const byMember = {};
    for (const record of records || []) {
        const start = toDateValue(record?.startDate);
        const end = toDateValue(record?.endDate);
        if (!record?.memberUid || !start || !end || end <= start) continue;
        const interval = {start, end, id: record.id || record.uid || null, reason: record.reason || 'Time off'};
        if (!byMember[record.memberUid]) byMember[record.memberUid] = [];
        byMember[record.memberUid].push(interval);
    }
    return byMember;
};

const timeOffCovering = (intervals, date) => {
    const at = toDateValue(date);
    if (!at) return null;
    return (intervals || []).find(({start, end}) => at >= start && at < end) || null;
};

module.exports = {timeOffIntervalsByMember, timeOffCovering};
